// Removes all spaces & special characters
export function hardTrim(str) {
  return  str.trim().replace(/[^a-z0-9]/gi, '');
}
export default hardTrim